export default {
  codigo: '',
  descricao: '',
  valor_custo: 0,
  valor_venda: 0,
  estoque: 0,
  unidade: 'UN'
}